// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store' // 导入store

import '@/icons' // icon
import '@/permission' // permission control


//可以把axios设置到原型里面，直接全局调用
//import Axios from 'axios'
//request.js里面是另外创建的
//Vue.prototype.$axios = Axios
//Axios.defaults.baseURL = '/api'
//Axios.defaults.headers.post['Content-Type'] = 'application/json';

Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   store,
//   components: { App },
//   template: '<App/>'
// });


let mainVm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});

export default mainVm



// WEBPACK FOOTER //
// ./src/main.js